<template>
    <div class="info-list">
        <Header/>
        <div class="user_reg" style="height:446px;">
            <div class="r_tit">重置密码</div>
            <div class="blank10"/>
            <div class="l-r-content">
                <ResetModule style="border:0px"/>
            </div>
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
import ResetModule from './components/reset'
export default {
    data() {
        return {
            
        }
    },
    components:{
        ResetModule,
    },
    created() {
    },
    methods: {
    },
}
</script>
<style lang="scss" scoped>
.info-list{
    background: #F0F0F0 !important;
}
</style>
